import { RangeFilter } from '../../../shared/models/range.model';

import { Serializable } from '../../../core/models/serializable';

export class AnnouncementsTotalsPerCustomerFilter
  implements Serializable<AnnouncementsTotalsPerCustomerFilter>
{
  fromObject(obj: any): AnnouncementsTotalsPerCustomerFilter {
    Object.assign(this, obj);
    return this;
  }

  toObject() {
    let result = {
      DateRange: this.dateRange,
      Group: this.group,
      ProviderWebsiteId: this.providerWebsiteId,
    };

    return result;
  }

  public dateRange: RangeFilter<Date>;
  public group: DateEnum;
  public providerWebsiteId: number;
}

export enum DateEnum {
  day = 1,
  week = 2,
  month = 3,
  year = 4,
}
